<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <CInput v-model="form.baptism_certificate_no"  label="Baptism Certificate No" placeholder=""  />
            <CInput v-model="form.baptism_date"  label="Baptism Date" type="date"  />
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
     
        </template>
    </CModal>
  </form>
</template>
<script>
import EventBus from '@/eventBus';

import member from '@/services/member';
import satelite from '@/services/satelitechurch'
import icare from '@/services/icare'

import moment from 'moment'

export default {
name: 'baptismmodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    form:{
      uuid: '',
      baptism_certificate_no: '',
      baptism_date: '',

    },
    }
  },
   mounted (){
     
      
   },
  
  created () {
    var self = this; 
      EventBus.$on('OPEN_MODAL_BAPTISM', (params) => {
      if(params.data){
      member.getBaptism(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = params.data;
      self.form.baptism_certificate_no = res.data.baptism_certificate_no;
      self.form.baptism_date = res.data.baptism_date;
       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.uuid = "";
        self.form.baptism_certificate_no = "";
        self.form.baptism_date = "";
      }
 
    });
    
  },
  mounted (){
 
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    update(id){
      this.show = false;
      this.form.baptism_date = moment(this.form.baptism_date).format ('DD/MM/YYYY')
      member.updateBaptism(id, this.form)
      .then(res => {
        EventBus.$emit('PAGE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
   
   
  }
}
</script>

<style>

</style>